/* eslint-disable */
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError} from 'rxjs/operators';
import { environment } from '../environments/environment';
import { RedirectService } from './services/redirect/redirect.service';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptor implements HttpInterceptor {
  private static didRedirectHappened = false;

  constructor(private router: Router, private redirectService: RedirectService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    req = req.clone({
      withCredentials: true
  });
    return next.handle(req).pipe(
      catchError((error: any) => {
        if (window.location.href.includes('login-error')) {
          const error = new Error('Login error detected.');
          console.error(error); // Log the error explicitly
          return throwError(error);
        }
        // If CORS error - browser cannot read any headers, i.e. `status: 0`.
        // CORS error in VG/Siteminder world means that session is invalid.
        const status = error.status;
        if ( !AuthInterceptor.didRedirectHappened ) {
          if (status === 401 && environment.internal) {
            // Navigate to login-error component for 401 Unauthorized
            AuthInterceptor.didRedirectHappened = true;
            this.router.navigate(['/login-error']);
          } else if ((status === 0 || status === 403) && !window.location.href.includes('login-error')) {
            // Redirect to external login for CORS or 403 errors (but not if already on login-error page)
            this.doRedirectToLogin();
          }
        }
        return throwError(error);
      }),
    );
  }

  doRedirectToLogin(): void {
    AuthInterceptor.didRedirectHappened = true;
    this.redirectService.redirectTo(environment.LOGON_URL);
  }
}
